export default __webpack_public_path__ + "static/media/home-corporate-hand-crafted-bg.85a3f511.jpg";